import {
    ADD_USAGES,
    ADD_ENV,
    ADD_INFO,
    ADD_USAGE_LIMIT
} from '../Constants/createInstance.constants';

const initalState = {
    usageDetails: {},
    environemtDetails: {},
    info: {},
    usageLimit: {}
};

export default (state = initalState, action) => {
    switch (action.type) {
        case ADD_USAGES:
            return {
                ...state,
                usageDetails: action.data
            };
        case ADD_ENV:
            return {
                ...state,
                environemtDetails: action.data
            };
        case ADD_INFO:
            return {
                ...state,
                info: action.data
            };
        case ADD_USAGE_LIMIT:
            return {
                ...state,
                usageLimit: action.data
            };
        default:
            return state;
    }
};
